"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from "lucide-react";
import Image from "next/image";
import { TransitionLink } from "@/components/transition-link";
import type { BlogPost } from "@/lib/blog";
import { cn } from "@/lib/utils";
import { useBlogCardHoverAnimation } from "./use-blog-card-hover-animation";
type BlogCardProps = {
  post: BlogPost;
  priority?: boolean;
  className?: string;
};
export function BlogCard(t0) {
  const $ = _c(25);
  const {
    post,
    priority: t1,
    className
  } = t0;
  const priority = t1 === undefined ? false : t1;
  const {
    handlePointerMove,
    handlePointerLeave
  } = useBlogCardHoverAnimation();
  const t2 = `/${post.slug}`;
  let t3;
  if ($[0] !== className) {
    t3 = cn("blog-card group block w-full max-w-full transform-gpu will-change-transform", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="blog-card-overlay pointer-events-none absolute inset-0 z-10 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.18),transparent_34%),linear-gradient(to_top,rgba(0,0,0,0.65),transparent_62%)] opacity-0" />;
    t5 = <span className="pointer-events-none absolute inset-0 z-10 ring-1 ring-white/10" />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== post.media || $[5] !== post.title || $[6] !== priority) {
    t6 = <div className="relative aspect-359/186 overflow-hidden bg-gray-1000">{t4}{t5}{post.media ? <Image src={post.media.url} alt={post.media.alternativeText ?? post.title} fill={true} className="blog-card-image object-cover will-change-transform" priority={priority} sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw" /> : <div className="absolute inset-0 bg-[linear-gradient(160deg,#191919_0%,#303030_100%)]" />}</div>;
    $[4] = post.media;
    $[5] = post.title;
    $[6] = priority;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== post.categories) {
    t7 = post.categories.slice(0, 2).map(_temp);
    $[8] = post.categories;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <div className="flex flex-wrap gap-2">{t7}</div>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== post.title) {
    t9 = <h2 className="max-w-88 text-lg leading-[160%] tracking-[0.01em] text-white transition group-hover:text-primary-300">{post.title}</h2>;
    $[12] = post.title;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="inline-flex items-center gap-3 text-base font-semibold leading-[160%] text-primary-300">Saiba mais<ArrowRight strokeWidth={1.75} className="blog-card-arrow size-5 will-change-transform" /></span>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t8 || $[16] !== t9) {
    t11 = <div className="blog-card-content flex flex-col gap-4 pt-8 will-change-transform">{t8}{t9}{t10}</div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== handlePointerLeave || $[19] !== handlePointerMove || $[20] !== t11 || $[21] !== t2 || $[22] !== t3 || $[23] !== t6) {
    t12 = <TransitionLink href={t2} onPointerMove={handlePointerMove} onPointerLeave={handlePointerLeave} className={t3}>{t6}{t11}</TransitionLink>;
    $[18] = handlePointerLeave;
    $[19] = handlePointerMove;
    $[20] = t11;
    $[21] = t2;
    $[22] = t3;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}
function _temp(category) {
  return <span key={category.id} className="inline-flex rounded-lg bg-[#272727] px-2.5 py-1.5 text-[11px] font-medium uppercase tracking-[0.01em] text-white">{category.reduce ?? category.name}</span>;
}